// extracted by mini-css-extract-plugin
module.exports = {"market-activity-indicator":"market-activity-indicator_market-activity-indicator__a1rcw"};